module.exports = __webpack_public_path__ + "static/media/_MG_9851.66f7a13a.jpg";